// extracted by mini-css-extract-plugin
export default {"container":"ReportsPage_container__m-9jX","title":"ReportsPage_title__3Vzta","exportButton":"ReportsPage_exportButton__cK3Rb","slideIn":"ReportsPage_slideIn__sElEf"};